export default __webpack_public_path__ + "static/media/LA.a4fe5b5c.svg";